import { Link } from "react-router-dom";
import { useApi } from "@/hooks/useApi";
import type { VoteBrief } from "@/lib/types";
import VoteMainCard from "@/pages/vote/components/VoteMainCard";

// 메인 홈 «진행중인 투표» 섹션.
// votes.php?main=1 은 «메인 노출 ON + 진행중» 인 것만 내려준다.
// 0건이면 섹션 자체를 렌더링하지 않는다.
export default function VoteSection() {
  const { data, loading } = useApi<VoteBrief[]>("votes.php?main=1");
  const list = (data ?? []).slice(0, 2);

  if (loading || list.length === 0) return null;

  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              진행중인 투표
            </h2>
            <p className="mt-2 text-foreground-600">
              지금 바로 참여하고 결과를 확인하세요.
            </p>
          </div>
          <Link
            to="/vote"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
          >
            전체 보기
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        <div
          className={`grid grid-cols-1 gap-5 ${
            list.length > 1 ? "md:grid-cols-2" : ""
          }`}
        >
          {list.map((vote) => (
            <VoteMainCard key={vote.no} brief={vote} />
          ))}
        </div>
      </div>
    </section>
  );
}